/** SSR hydration guard for Zustand persist middleware.
 *  Returns false on server and during initial client render,
 *  true once localStorage state has been rehydrated. */

import { useEffect, useState } from "react";

export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
